/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Correct_LabelInputs */

const bn_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সঠিক`)
};

const de_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richtig`)
};

const el_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σωστός`)
};

const en_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct`)
};

const es_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correcto`)
};

const fr_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct`)
};

const hi_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सही`)
};

const hu_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helyes`)
};

const id_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benar`)
};

const it_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corretto`)
};

const ja_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正しい`)
};

const ko_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`옳은`)
};

const nl_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juist`)
};

const pl_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawidłowy`)
};

const pt_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correto`)
};

const ru_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правильный`)
};

const sv_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rätta`)
};

const tr_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğru`)
};

const uk_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правильно`)
};

const vi_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chính xác`)
};

const zh_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正确的`)
};

const zh_hant_game_correct_label = /** @type {(inputs: Game_Correct_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正確的`)
};

/**
* | output |
* | --- |
* | "Correct" |
*
* @param {Game_Correct_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_correct_label = /** @type {((inputs?: Game_Correct_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Correct_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_correct_label(inputs)
	if (locale === "de") return de_game_correct_label(inputs)
	if (locale === "el") return el_game_correct_label(inputs)
	if (locale === "en") return en_game_correct_label(inputs)
	if (locale === "es") return es_game_correct_label(inputs)
	if (locale === "fr") return fr_game_correct_label(inputs)
	if (locale === "hi") return hi_game_correct_label(inputs)
	if (locale === "hu") return hu_game_correct_label(inputs)
	if (locale === "id") return id_game_correct_label(inputs)
	if (locale === "it") return it_game_correct_label(inputs)
	if (locale === "ja") return ja_game_correct_label(inputs)
	if (locale === "ko") return ko_game_correct_label(inputs)
	if (locale === "nl") return nl_game_correct_label(inputs)
	if (locale === "pl") return pl_game_correct_label(inputs)
	if (locale === "pt") return pt_game_correct_label(inputs)
	if (locale === "ru") return ru_game_correct_label(inputs)
	if (locale === "sv") return sv_game_correct_label(inputs)
	if (locale === "tr") return tr_game_correct_label(inputs)
	if (locale === "uk") return uk_game_correct_label(inputs)
	if (locale === "vi") return vi_game_correct_label(inputs)
	if (locale === "zh") return zh_game_correct_label(inputs)
	return zh_hant_game_correct_label(inputs)
});